{
  "tabs": {
    "chat": "Trò chuyện",
    "reminders": "Nhắc nhở",
    "calendar": "Lịch",
    "settings": "Cài đặt"
  },
  "common": {
    "cancel": "Hủy",
    "save": "Lưu",
    "confirm": "Xác nhận",
    "delete": "Xóa",
    "back": "Quay lại",
    "close": "Đóng",
    "edit": "Sửa",
    "search": "Tìm kiếm",
    "all": "Tất cả",
    "loading": "Đang tải...",
    "error": "Có lỗi xảy ra",
    "notFound": "Không tìm thấy",
    "tryAgain": "Vui lòng thử lại",
    "retry": "Thử lại",
    "undo": "Hoàn tác",
    "pullToRefresh": "Kéo để làm mới",
    "justNow": "vừa xong"
  },
  "auth": {
    "welcome": "Chào mừng đến với FishMemory",
    "tagline": "Trợ lý nhắc nhở WhatsApp của bạn, giờ trong túi bạn.",
    "subtitle": "Trợ lý nhắc nhở WhatsApp của bạn, giờ trong túi bạn.",
    "phoneLabel": "Số WhatsApp của bạn",
    "phoneHint": "Chúng tôi sẽ gửi mã xác minh qua WhatsApp",
    "invalidPhone": "Vui lòng nhập số điện thoại hợp lệ",
    "continue": "Tiếp tục",
    "enterPhone": "Nhập số WhatsApp của bạn",
    "phonePlaceholder": "Số điện thoại",
    "sendCode": "Gửi mã",
    "verifyTitle": "Xác minh số của bạn",
    "otpSentTo": "Mã 6 chữ số đã được gửi đến {{phone}} qua WhatsApp",
    "enterFullCode": "Vui lòng nhập đủ 6 chữ số",
    "invalidOtp": "Mã không hợp lệ. Vui lòng thử lại.",
    "otpFailed": "Gửi mã thất bại. Thử lại.",
    "otpResent": "Đã gửi lại mã",
    "resendIn": "Gửi lại sau {{seconds}} giây",
    "resendCode": "Gửi lại mã",
    "enterOtp": "Nhập mã gửi đến WhatsApp của bạn",
    "verify": "Xác minh",
    "resend": "Gửi lại mã",
    "wrongNumber": "Sai số?",
    "backToPhone": "Quay lại số điện thoại",
    "editPhone": "Sửa số điện thoại",
    "error": "Lỗi",
    "setupTitle": "Cùng thiết lập",
    "setupSubtitle": "Bạn có thể thay đổi sau trong Cài đặt",
    "namePlaceholder": "Tên của bạn",
    "letsGo": "Hoàn tất thiết lập",
    "skipForNow": "Bỏ qua"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Nhập tin nhắn...",
    "inputPlaceholder": "Nhập tin nhắn...",
    "typing": "FishMemory đang nhập...",
    "online": "Trực tuyến",
    "connecting": "Đang kết nối...",
    "reconnecting": "Đang kết nối lại...",
    "offline": "Ngoại tuyến",
    "empty": "Bắt đầu trò chuyện",
    "emptyHint": "Tạo nhắc nhở, xem lịch hoặc hỏi trợ giúp.",
    "emptyAction": "Gửi nhắc nhở mẫu",
    "actions": "Hành động chat",
    "keep": "Giữ tin nhắn",
    "clearTitle": "Xóa chat",
    "clearConfirm": "Xóa tất cả tin nhắn trên thiết bị này? Không thể hoàn tác.",
    "clear": "Xóa chat",
    "optionSelected": "Đã chọn: {{label}}",
    "sendingSelection": "Đang gửi...",
    "connectionLost": "Đang kết nối lại..."
  },
  "reminders": {
    "title": "Nhắc nhở của tôi",
    "active": "Đang hoạt động",
    "today": "Hôm nay",
    "thisWeek": "Tuần này",
    "history": "Lịch sử",
    "items": "mục",
    "emptyTitle": "Chưa có nhắc nhở",
    "emptySubtitle": "Tạo nhắc nhở từ chat sẽ hiển thị ở đây.",
    "emptyAction": "Mở chat",
    "filterActive": "Đang hoạt động",
    "filterToday": "Hôm nay",
    "filterWeek": "Tuần này",
    "filterHistory": "Lịch sử",
    "emptyState": "Chưa có nhắc nhở. Bắt đầu trò chuyện!",
    "swipeDone": "Hoàn thành",
    "swipeSnooze": "Hoãn",
    "swipeDelete": "Xóa",
    "search": "Tìm nhắc nhở...",
    "upcoming": "Sắp tới",
    "completed": "Đã hoàn thành",
    "overdue": "Quá hạn",
    "tomorrow": "Ngày mai",
    "synced": "Đã đồng bộ {{value}}",
    "swipeHint": "Vuốt nhắc nhở để xem thêm hành động",
    "noResults": "Không có nhắc nhở phù hợp",
    "noResultsHint": "Thử từ khóa khác hoặc xóa tìm kiếm",
    "deleteAllFailed": "Xóa tất cả nhắc nhở thất bại"
  },
  "calendar": {
    "title": "Lịch",
    "today": "Hôm nay",
    "tomorrow": "Ngày mai",
    "completed": "đã xong",
    "noEvents": "Không có sự kiện",
    "noEventsSubtitle": "Chọn ngày để xem nhắc nhở và sự kiện lịch.",
    "googleEvent": "Lịch Google",
    "legendActive": "Đang hoạt động",
    "legendRecurring": "Lặp lại",
    "legendDone": "Hoàn thành",
    "legendGoogle": "Google",
    "previousMonth": "Tháng trước",
    "nextMonth": "Tháng sau",
    "previousYear": "Năm trước",
    "nextYear": "Năm sau",
    "goToToday": "Đến hôm nay",
    "all": "Tất cả",
    "active": "Đang hoạt động",
    "done": "Hoàn thành",
    "paused": "Tạm dừng"
  },
  "settings": {
    "title": "Cài đặt",
    "profile": "Hồ sơ",
    "name": "Tên hiển thị",
    "enterName": "Nhập tên của bạn",
    "language": "Ngôn ngữ",
    "uiLanguage": "Ngôn ngữ ứng dụng",
    "uiLanguageHelp": "Thay đổi giao diện, nhãn lịch và hướng bố cục chỉ trên thiết bị này.",
    "serverLanguage": "Ngôn ngữ chat",
    "serverLanguageHelp": "Thay đổi ngôn ngữ phản hồi máy chủ và tin nhắn nhắc nhở cho tài khoản bạn.",
    "timezone": "Múi giờ",
    "currentTimezone": "Múi giờ hiện tại",
    "timezoneHelp": "Tất cả thời gian nhắc nhở hiển thị theo múi giờ này.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Lưu múi giờ",
    "timezoneSaved": "Đã cập nhật múi giờ",
    "detect": "Phát hiện",
    "detectFailed": "Không thể phát hiện múi giờ",
    "autoDetect": "Tự động phát hiện qua GPS",
    "notifications": "Thông báo",
    "notificationsHelp": "Nhắc nhở theo dõi kiểm soát cảnh báo lặp lại sau khi nhắc nhở được gửi. Quyền thông báo cấp thiết bị vẫn do cài đặt điện thoại quản lý.",
    "pushEnabled": "Thông báo đẩy",
    "autoDoneOnFire": "Tự động đánh dấu hoàn thành khi nhắc",
    "autoDoneOnFireDesc": "Khi tắt, nhắc nhở vẫn hoạt động cho đến khi bạn đánh dấu hoàn thành.",
    "googleCalendar": "Lịch Google",
    "google": "Lịch Google",
    "googleConnected": "Đã kết nối",
    "googleDisconnected": "Chưa kết nối",
    "googleConnectedHelp": "Nhắc nhở mới có thể tự động đồng bộ vào lịch của bạn.",
    "googleDisconnectedHelp": "Kết nối Lịch Google để đồng bộ nhắc nhở và sự kiện.",
    "googleConnectFailed": "Kết nối Lịch Google thất bại",
    "connected": "Đã kết nối",
    "disconnected": "Chưa kết nối",
    "connect": "Kết nối",
    "disconnect": "Ngắt kết nối",
    "autoSync": "Tự động đồng bộ nhắc nhở mới",
    "autosync": "Tự động đồng bộ nhắc nhở mới",
    "subscription": "Đăng ký",
    "trialUsed": "Dùng thử: {{used}}/{{total}} đã dùng",
    "trialStatus": "Có bản dùng thử",
    "activeStatus": "Đăng ký đang hoạt động",
    "expiredStatus": "Đăng ký đã hết hạn",
    "unsubscribedStatus": "Chưa đăng ký",
    "about": "Giới thiệu",
    "version": "Phiên bản",
    "logout": "Đăng xuất",
    "logoutTitle": "Đăng xuất",
    "logoutConfirm": "Bạn có chắc muốn đăng xuất?",
    "noName": "Chưa đặt tên",
    "serverConnection": "Kết nối máy chủ",
    "serverUrl": "URL máy chủ",
    "serverEdit": "Sửa",
    "saveReconnect": "Lưu và kết nối lại",
    "resetDefault": "Đặt lại mặc định",
    "invalidServerUrlTitle": "URL máy chủ không hợp lệ",
    "invalidServerUrlMessage": "Nhập URL máy chủ http hoặc https hợp lệ, ví dụ https://example.com",
    "uiLanguageChangeFailed": "Thay đổi ngôn ngữ ứng dụng thất bại. Vui lòng thử lại.",
    "serverLanguageChangeFailed": "Thay đổi ngôn ngữ chat thất bại. Vui lòng thử lại.",
    "timezoneChangeFailed": "Thay đổi múi giờ thất bại. Vui lòng thử lại.",
    "autoSyncChangeFailed": "Cập nhật tự động đồng bộ thất bại. Vui lòng thử lại.",
    "nameChangeFailed": "Cập nhật tên hiển thị thất bại. Vui lòng thử lại.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Chi tiết nhắc nhở",
    "editTime": "Sửa thời gian",
    "rename": "Đổi tên",
    "snooze": "Hoãn",
    "snooze15": "Hoãn 15 phút",
    "pause": "Tạm dừng",
    "pauseReminder": "Tạm dừng nhắc nhở",
    "resume": "Tiếp tục",
    "resumeReminder": "Tiếp tục nhắc nhở",
    "skip": "Bỏ qua lần sau",
    "skipOccurrence": "Bỏ qua lần này",
    "syncGoogle": "Đồng bộ Google",
    "delete": "Xóa",
    "deleteTitle": "Xóa nhắc nhở",
    "deleteConfirm": "Nhắc nhở này sẽ bị xóa vĩnh viễn.",
    "deleteRecurringTitle": "Xóa nhắc nhở lặp lại",
    "deleteRecurringMessage": "Bạn muốn bỏ qua lần này hay xóa toàn bộ chuỗi?",
    "deleteThisOccurrence": "Bỏ qua lần này",
    "deleteEntireSeries": "Xóa toàn bộ chuỗi",
    "done": "Xong",
    "markDone": "Đánh dấu đã xong",
    "undo": "Khôi phục",
    "undoPrompt": "Cần nhắc lại? Khôi phục ngay.",
    "recurring": "Lặp lại",
    "nextRun": "Lần tiếp theo",
    "oneTime": "Một lần",
    "pending": "Đang chờ",
    "sent": "Đã gửi",
    "paused": "Đã tạm dừng",
    "active": "Đang hoạt động",
    "snoozed": "Đã hoãn",
    "localTime": "Hiển thị theo giờ địa phương",
    "recurrence": "Tần suất lặp",
    "created": "Đã tạo",
    "tags": "Thẻ",
    "fireCount": "Số lần nhắc",
    "actions": "Hành động",
    "none": "Không có",
    "snoozeFailed": "Hoãn nhắc nhở thất bại",
    "pauseFailed": "Tạm dừng nhắc nhở thất bại",
    "resumeFailed": "Tiếp tục nhắc nhở thất bại",
    "skipFailed": "Bỏ qua nhắc nhở thất bại",
    "doneFailed": "Đánh dấu hoàn thành thất bại",
    "undoFailed": "Khôi phục trạng thái thất bại",
    "deleteFailed": "Xóa nhắc nhở thất bại",
    "rescheduleTitle": "Đặt lại lịch?",
    "rescheduleMsg": "Nhắc nhở này đã quá hạn. Bạn có muốn đặt lại không?",
    "reschedule15": "Sau 15 phút",
    "reschedule60": "Sau 1 giờ",
    "keepOverdue": "Giữ nguyên"
  },
  "onboarding": {
    "slide1Title": "Chào mừng đến với FishMemory",
    "slide1Sub": "Trợ lý nhắc nhở cá nhân — dựa trên WhatsApp và dành cho túi bạn.",
    "slide2Title": "Chỉ cần chat tự nhiên",
    "slide2Sub": "Gõ nhắc nhở theo cách bạn nghĩ: \"Nhắc tôi gọi mẹ ngày mai lúc 3 giờ chiều\" — chúng tôi lo phần còn lại.",
    "slide3Title": "Không bỏ lỡ điều gì",
    "slide3Sub": "Nhận thông báo đúng giờ, tổ chức với thẻ, và kiểm soát mọi việc quan trọng.",
    "getStarted": "Bắt đầu",
    "next": "Tiếp",
    "firstReminderTitle": "Tạo nhắc nhở đầu tiên!",
    "firstReminderHint": "Thử gõ như:",
    "firstReminderExample": "Nhắc tôi uống nước ngày mai lúc 9 giờ sáng",
    "gotIt": "Đã hiểu!",
    "notifRationaleTitle": "Đúng giờ",
    "notifRationaleBody": "FishMemory cần thông báo để nhắc bạn đúng lúc. Bạn chỉ nhận cảnh báo cho nhắc nhở bạn tạo.",
    "notifRationaleAllow": "Bật thông báo",
    "notifRationaleLater": "Để sau",
    "swipeHint": "Vuốt phải để thao tác nhanh →",
    "calendarDragHint": "Kéo để mở rộng ↕"
  }
}
